var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center vh-100"},[_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary p-4 fs-3",on:{"click":function($event){return _vm.$router.push({ name: 'terrains' })}}},[_vm._v(" Choisissez le terrain de jeu en cliquant ici ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }